import { render, staticRenderFns } from "./PrCol.vue?vue&type=template&id=0e220200"
import script from "./PrCol.vue?vue&type=script&lang=js"
export * from "./PrCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports